import { z } from 'zod'
import {
  benefitAndVoucherManagementGetSelectCourtesyArrangementsItineraryInformationSchema,
  courtesyArrangementsListSchema
} from './benefit-and-voucher-management-get-select-courtesy-arrangements'

export const travelAssistantGetCourtesyResponseSchema = z.object({
  /** 行程資訊 */
  itineraryInformation: z.array(
    benefitAndVoucherManagementGetSelectCourtesyArrangementsItineraryInformationSchema
  ),
  /** 禮遇安排 */
  courtesyArrangements: z.array(courtesyArrangementsListSchema),
  /** 是否有使用禮遇項目 */
  usedCourtesy: z.boolean(),
  /** 排除行程 */
  excludeItinerary: z.boolean()
})

export interface TravelAssistantGetCourtesyResponse
  extends z.infer<typeof travelAssistantGetCourtesyResponseSchema> {}

export class TravelAssistantGetCourtesyResponse {
  constructor() {
    return {
      itineraryInformation: [],
      courtesyArrangements: [],
      usedCourtesy: false,
      excludeItinerary: false
    }
  }
}
